import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import CropperImage from './cropper.component';
import { ReactComponent as AppleIcon } from '../../assets/svg/apple.svg';
import { ReactComponent as AndroidIcon } from '../../assets/svg/android.svg';
import MarkerEditor from './markerEditor.component';

const ImageModal = ({
  showImageEditor,
  setShowImageEditor,
  imageHandleClose,
  blobURL,
  setBlobURL,
  setTab,
  tab,
  setPreviewScreen,
  previewScreen,
  imageEditData,
  setImageEditData,
  saveImageToGallery = false,
  isSaveAsNew,
}) => {
  const [showMobile, setShowMobile] = useState('ios');
  const [showIosDeviceType, setShowIosDeviceType] = useState('old');
  const [markerState, setMarkerState] = useState();
  const [blobData, setBlobData] = useState();
  const changeMobile = (modelName) => {
    setShowMobile(modelName);
  };

  const [isAsNew, setIsAsNew] = useState(false);

  const handleImageSave = () => {
    setTab(1);
    setShowImageEditor(false);
    setPreviewScreen((prevState) => ({
      ...prevState,
      image: blobData,
      isAsNew: isAsNew,
    }));
    saveImageToGallery && saveImageToGallery(isAsNew);
    setIsAsNew(false);
  };

  return (
    <>
      <Modal
        size='lg'
        show={showImageEditor}
        onHide={imageHandleClose}
        className='photo-edit-modal'
        backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>Image Editing</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ zIndex: 10000 }}>
            {tab && tab === 1 && (
              <CropperImage
                path={blobURL.current}
                setBlobURL={setBlobURL}
                blobURL={blobURL}
                setShowImageEditor={setShowImageEditor}
                setPreviewScreen={setPreviewScreen}
                setTab={setTab}
                imageEditData={imageEditData}
                setImageEditData={setImageEditData}
                setMarkerState={setMarkerState}
              />
            )}
            {tab && tab === 2 && (
              <MarkerEditor
                path={blobURL.next}
                setBlobURL={setBlobURL}
                blobURL={blobURL}
                setTab={setTab}
                setBlobData={setBlobData}
                setMarkerState={setMarkerState}
                markerState={markerState}
                isSaveAsNew={isSaveAsNew}
                setIsAsNew={setIsAsNew}
              />
            )}
            {tab && tab === 3 && (
              <div className='col-12 col-lg-12 col-md-12 col-sm-12'>
                <div className='contact-mobile-wrapper'>
                  <div className='mobile-tab-wrapper'>
                    <ul>
                      <li
                        className={showMobile === 'ios' ? 'active' : ''}
                        onClick={() => changeMobile('ios')}>
                        <AppleIcon />
                      </li>
                      <li
                        className={showMobile === 'android' ? 'active' : ''}
                        onClick={() => changeMobile('android')}>
                        <AndroidIcon />
                      </li>
                    </ul>
                    {showMobile === 'ios' && (
                      <ul className='ios-mobile-type'>
                        <li
                          className={
                            showIosDeviceType === 'old' ? 'active' : ''
                          }
                          onClick={() => setShowIosDeviceType('old')}>
                          <span>1</span>
                        </li>
                        <li
                          className={
                            showIosDeviceType === 'new' ? 'active' : ''
                          }
                          onClick={() => setShowIosDeviceType('new')}>
                          <span>2</span>
                        </li>
                      </ul>
                    )}
                  </div>
                  <div
                    className='mobile-wrapper ios'
                    id='ios'
                    style={{
                      display:
                        showMobile === 'ios' && showIosDeviceType === 'old'
                          ? 'block'
                          : 'none',
                    }}>
                    <div className='mobile-key silent'></div>
                    <div className='mobile-key volume-up'></div>
                    <div className='mobile-key volume-down'></div>
                    <div className='mobile-key power'></div>
                    <div
                      className='mobile-frame'
                      style={{
                        backgroundSize: 'contain',
                        backgroundImage: `url(${blobURL.next})`,
                      }}>
                      <div className='mobile-content'>
                        <h4 className='name'>
                          {previewScreen.formatName}
                          {/* {previewScreen.firstName} {previewScreen.lastName} */}
                          {/* {`${previewScreen.prefixName}${previewScreen.firstName} ${previewScreen.lastName}`} */}
                        </h4>
                        {/* <p className='number'>{previewScreen.phone}</p> */}
                        <p className='number'>main</p>
                      </div>
                      <div className='preview-screen-action'>
                        <ul className='extra-content'>
                          <li className='remind-me'>
                            <a href='#!'>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                className='ionicon'
                                viewBox='0 0 512 512'>
                                <path d='M153.59 110.46A21.41 21.41 0 00152.48 79 62.67 62.67 0 00112 64l-3.27.09h-.48C74.4 66.15 48 95.55 48.07 131c0 19 8 29.06 14.32 37.11a20.61 20.61 0 0014.7 7.8c.26 0 .7.05 2 .05a19.06 19.06 0 0013.75-5.89zM403.79 64.11l-3.27-.1H400a62.67 62.67 0 00-40.52 15 21.41 21.41 0 00-1.11 31.44l60.77 59.65a19.06 19.06 0 0013.79 5.9c1.28 0 1.72 0 2-.05a20.61 20.61 0 0014.69-7.8c6.36-8.05 14.28-18.08 14.32-37.11.06-35.49-26.34-64.89-60.15-66.93z' />
                                <path d='M256.07 96c-97 0-176 78.95-176 176a175.23 175.23 0 0040.81 112.56l-36.12 36.13a16 16 0 1022.63 22.62l36.12-36.12a175.63 175.63 0 00225.12 0l36.13 36.12a16 16 0 1022.63-22.62l-36.13-36.13A175.17 175.17 0 00432.07 272c0-97-78.95-176-176-176zm16 176a16 16 0 01-16 16h-80a16 16 0 010-32h64v-96a16 16 0 0132 0z' />
                              </svg>
                              <span>Remind Me</span>
                            </a>
                          </li>
                          <li className='remind-me'>
                            <a href='#!'>
                              <i className='fa fa-comment'></i>
                              <span>Message</span>
                            </a>
                          </li>
                        </ul>
                        <ul className='phone-content'>
                          <li className='call-icon decline'>
                            <a href='#!'>
                              <i className='fas fa-phone'></i>
                            </a>
                            <span className='desc'>Decline</span>
                          </li>
                          <li className='call-icon accept'>
                            <a href='#!'>
                              <i className='fas fa-phone'></i>
                            </a>
                            <span className='desc'>Accept</span>
                          </li>
                        </ul>
                      </div>
                      <div className='mobile-notch'>
                        <div className='ear-speaker'></div>
                        <div className='front-camera'></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='mobile-wrapper ios new-phone ios-full-control'
                    id='ios'
                    style={{
                      display:
                        showMobile === 'ios' && showIosDeviceType === 'new'
                          ? 'block'
                          : 'none',
                    }}>
                    <div className='mobile-key silent'></div>
                    <div className='mobile-key volume-up'></div>
                    <div className='mobile-key volume-down'></div>
                    <div className='mobile-key power'></div>
                    <div
                      className='mobile-frame'
                      style={{
                        backgroundSize: 'contain',
                        backgroundImage: `url(${blobURL.next})`,
                      }}>
                      <div className='mobile-content'>
                        <h4 className='name'>
                          {/* {previewScreen.firstName} {previewScreen.lastName} */}
                          {/* {`${previewScreen.prefixName}${previewScreen.firstName} ${previewScreen.lastName}`} */}

                          {previewScreen.formatName}
                        </h4>
                        {/* <p className='number'>{previewScreen.phone}</p> */}
                        <p className='number'>main</p>
                      </div>
                      <div className='preview-screen-action'>
                        <ul className='extra-content'>
                          <li className='remind-me'>
                            <a href='#!'>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                className='ionicon'
                                viewBox='0 0 512 512'>
                                <path d='M153.59 110.46A21.41 21.41 0 00152.48 79 62.67 62.67 0 00112 64l-3.27.09h-.48C74.4 66.15 48 95.55 48.07 131c0 19 8 29.06 14.32 37.11a20.61 20.61 0 0014.7 7.8c.26 0 .7.05 2 .05a19.06 19.06 0 0013.75-5.89zM403.79 64.11l-3.27-.1H400a62.67 62.67 0 00-40.52 15 21.41 21.41 0 00-1.11 31.44l60.77 59.65a19.06 19.06 0 0013.79 5.9c1.28 0 1.72 0 2-.05a20.61 20.61 0 0014.69-7.8c6.36-8.05 14.28-18.08 14.32-37.11.06-35.49-26.34-64.89-60.15-66.93z' />
                                <path d='M256.07 96c-97 0-176 78.95-176 176a175.23 175.23 0 0040.81 112.56l-36.12 36.13a16 16 0 1022.63 22.62l36.12-36.12a175.63 175.63 0 00225.12 0l36.13 36.12a16 16 0 1022.63-22.62l-36.13-36.13A175.17 175.17 0 00432.07 272c0-97-78.95-176-176-176zm16 176a16 16 0 01-16 16h-80a16 16 0 010-32h64v-96a16 16 0 0132 0z' />
                              </svg>
                              <span>Remind Me</span>
                            </a>
                          </li>
                          <li className='remind-me'>
                            <a href='#!'>
                              <i className='fa fa-comment'></i>
                              <span>Message</span>
                            </a>
                          </li>
                        </ul>
                        <ul className='phone-content'>
                          <li className='call-icon'>
                            <a href='#!'>
                              <i className='fas fa-phone'></i>
                            </a>
                          </li>
                          <span className='msg'>slide to answer</span>
                        </ul>
                      </div>
                      <div className='mobile-notch'>
                        <div className='ear-speaker'></div>
                        <div className='front-camera'></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='mobile-wrapper android'
                    id='android'
                    style={{
                      display: showMobile === 'android' ? 'block' : 'none',
                    }}>
                    <div className='mobile-key volume-up-down'></div>
                    <div className='mobile-key power'></div>
                    <div
                      className='mobile-frame'
                      style={{
                        backgroundSize: 'contain',
                        backgroundImage: `url(${blobURL.next})`,
                      }}>
                      <div className='mobile-content'>
                        {/* <div className='call-title'>
                          <label>Dialing...</label>
                        </div> */}
                        <h4 className='name'>
                          {previewScreen.formatName}
                          {/* {`${previewScreen.prefixName}${previewScreen.firstName} ${previewScreen.lastName}`} */}
                          {/* {previewScreen.firstName} {previewScreen.lastName} */}
                        </h4>
                        <p className='number mobile-number'>
                          {previewScreen.phone &&
                            previewScreen.phone
                              .toString()
                              .replace(/\D+/g, '')
                              .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}
                        </p>
                      </div>
                      <div className='preview-screen-action'>
                        <ul>
                          <li className='call-icon start'>
                            <a href='#!'>
                              <i className='fas fa-phone-alt'></i>
                            </a>
                            {/* <span>Accept</span> */}
                          </li>
                          <li className='call-icon end'>
                            <a href='#!'>
                              <i className='fas fa-phone-alt'></i>
                            </a>
                            {/* <span>decline</span> */}
                          </li>
                        </ul>
                      </div>
                      <div className='mobile-notch'>
                        <div className='front-camera'></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='img-editing-action-btn'>
                  <button
                    className='btn btn-primary'
                    onClick={(e) => {
                      setTab(2);
                      setBlobURL({
                        ...blobURL,
                        next: blobURL.current,
                      });
                    }}>
                    Back
                  </button>
                  <button className='btn btn-primary' onClick={handleImageSave}>
                    Save
                  </button>

                  {/* {isSaveAsNew ? (
                    <>
                      <button
                        className='btn btn-primary'
                        onClick={(e) => {
                          handleImageSave();
                        }}>
                        Save
                      </button>
                      <button
                        className='btn btn-primary'
                        onClick={(e) => {
                          handleImageSave();
                        }}>
                        Save as new image
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className='btn btn-primary'
                        onClick={(e) => {
                          handleImageSave();
                        }}>
                        Save
                      </button>
                    </>
                  )} */}
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <div className=''>
            <button
              className='btn btn-primary'
              onClick={(e) => {
                setTab(2);
                setBlobURL({
                  ...blobURL,
                  next: blobURL.current,
                });
              }}
            >
              Back
            </button>
            <button
              className='btn btn-primary ms-2'
              onClick={(e) => {
                handleImageSave();
              }}
            >
              Save
            </button>
          </div>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default ImageModal;
